module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-zoom-out-4310047ecbc33efb114710851b8e966b.png";